import Headroom from 'headroom.js';
export default function headerInit() {
  // const bodyClasses = document.body.classList;
  // const header = document.getElementById("main-header");

  const header = document.querySelector('header.sticky-top');
  function setTopSpacing() {
    document.documentElement.style.setProperty(
      '--top-spacing',
      `${header.offsetHeight}px`
    );
  }
  if (header) {
    setTopSpacing();
    window.addEventListener('resize', () => setTopSpacing());
  }
  const headroom = new Headroom(header);
  headroom.init();
}
